import { render, staticRenderFns } from "./EditarCaso.vue?vue&type=template&id=78262c82&"
import script from "./EditarCaso.vue?vue&type=script&lang=js&"
export * from "./EditarCaso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports